(() => {
  'use strict';

  class DreamCurlsSliderCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dcsInitialized) return;

      if (typeof window.EmblaCarousel !== 'function') {
        console.warn('Dream Curls Slider: EmblaCarousel is not available.');
        return;
      }

      this.dcsInitialized = true;
      this.setup();
    }

    setup() {
      const root = this;

      const setSelectedSlide = (emblaApi) => {
        const nodes = emblaApi.slideNodes();
        const previous = emblaApi.previousScrollSnap();
        const selected = emblaApi.selectedScrollSnap();

        if (previous === selected || selected < 0 || selected >= nodes.length) return;

        const selectedNode = nodes[selected];

        const desktopElements = {
          name: root.querySelector('[data-desktop-name]'),
          stars: root.querySelector('[data-desktop-stars]'),
          content: root.querySelector('[data-desktop-content]'),
        };

        const mobileElements = {
          name: selectedNode.querySelector('[data-name]'),
          stars: selectedNode.querySelector('[data-stars]'),
          content: selectedNode.querySelector('[data-content]'),
        };

        Object.keys(desktopElements).forEach((key) => {
          if (mobileElements[key]) {
            desktopElements[key].innerHTML = mobileElements[key].innerHTML;
          }
        });

        nodes[previous].classList.add('inactive-slide');
        nodes[selected].classList.remove('inactive-slide');
      };

      const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
        const togglePrevNextBtnsState = () => {
          if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled');
          else prevBtn.setAttribute('disabled', 'disabled');

          if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled');
          else nextBtn.setAttribute('disabled', 'disabled');
        };

        emblaApi
          .on('select', togglePrevNextBtnsState)
          .on('init', togglePrevNextBtnsState)
          .on('reInit', togglePrevNextBtnsState);

        return () => {
          prevBtn.removeAttribute('disabled');
          nextBtn.removeAttribute('disabled');
        };
      };

      const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
        const scrollPrev = () => {
          emblaApi.scrollPrev();

          setSelectedSlide(emblaApi);
        };
        const scrollNext = () => {
          emblaApi.scrollNext();

          setSelectedSlide(emblaApi);
        };
        prevBtn.addEventListener('click', scrollPrev, false);
        nextBtn.addEventListener('click', scrollNext, false);

        const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
          emblaApi,
          prevBtn,
          nextBtn
        );

        return () => {
          removeTogglePrevNextBtnsActive();
          prevBtn.removeEventListener('click', scrollPrev, false);
          nextBtn.removeEventListener('click', scrollNext, false);
        };
      };

      const addDotBtnsAndClickHandlers = (emblaApi, dotsNode) => {
        let dotNodes = [];

        const addDotBtnsWithClickHandlers = () => {
          dotsNode.innerHTML = emblaApi
            .scrollSnapList()
            .map(() => '<button class="embla__dot" type="button"></button>')
            .join('');

          const scrollTo = (index) => {
            emblaApi.scrollTo(index);
          };

          dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'));
          dotNodes.forEach((dotNode, index) => {
            dotNode.addEventListener('click', () => scrollTo(index), false);
          });
        };

        const toggleDotBtnsActive = () => {
          const previous = emblaApi.previousScrollSnap();
          const selected = emblaApi.selectedScrollSnap();
          dotNodes[previous].classList.remove('embla__dot--selected');
          dotNodes[selected].classList.add('embla__dot--selected');
        };

        emblaApi
          .on('init', addDotBtnsWithClickHandlers)
          .on('reInit', addDotBtnsWithClickHandlers)
          .on('init', toggleDotBtnsActive)
          .on('reInit', toggleDotBtnsActive)
          .on('select', toggleDotBtnsActive);

        return () => {
          dotsNode.innerHTML = '';
        };
      };

      const OPTIONS = { align: 'start' };

      const emblaNode = root.querySelector('.embla.dream-curls-embla');
      if (!emblaNode) return;

      const viewportNode = emblaNode.querySelector('.embla__viewport');
      const dotsNode = emblaNode.querySelector('.embla__dots');
      const prevBtnNode = root.querySelector('.arrow-prev');
      const nextBtnNode = root.querySelector('.arrow-next');

      const emblaApi = window.EmblaCarousel(viewportNode, OPTIONS);

      const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
        emblaApi,
        prevBtnNode,
        nextBtnNode
      );

      const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
        emblaApi,
        dotsNode
      );

      emblaApi.on('select', () => {
        setSelectedSlide(emblaApi);
      });

      emblaApi.on('destroy', removePrevNextBtnsClickHandlers);
      emblaApi.on('destroy', removeDotBtnsAndClickHandlers);

      root.querySelectorAll('.slider-video-player').forEach((wrapper, index, wrappers) => {
        const playButton = wrapper.querySelector('.play-btn');
        const video = wrapper.querySelector('video');

        playButton.addEventListener('click', () => {
          wrappers.forEach((e) => {
            e.querySelector('video').pause();
            e.querySelector('.play-btn').classList.remove('hidden');
          });

          playButton.classList.add('hidden');
          video.play();

          video.addEventListener('click', () => {
            video.pause();
            playButton.classList.remove('hidden');
          });
        });
      });
    }
  }

  if (!customElements.get('dream-curls-slider-carousel')) {
    customElements.define('dream-curls-slider-carousel', DreamCurlsSliderCarousel);
  }
})();
